import {useEffect} from "react"
import progressIcon from "../../assets/icon/progress.svg"
import {useTranslation} from "react-i18next"
import ScrollingMod from "../../tools/ScrollingMod"
import {useLocalContext} from "../../reactContext/contextCustomHooks/useLocalContext"

export default function LoadingModal({display, trie}) {
    const {t} = useTranslation()
    const {localContext} = useLocalContext()
    const steps = {
        "upload": "Media being uploaded",
        "lexicons": "Media being transcribed",
        "lexiconsDone": "Media being transcribed",
        "transcription": "Media being transcribed",
        "translation": "Media being translated",
        "generate_all_ecp": "Project being generated",
        "abstract": "Abstract being regenerated",
        "summary": "Summary being regenerated",
        "keypoints": "Keypoints being regenerated",
        "verbatims": "Verbatims being regenerated",
        "glossary": "Glossary being regenerated",
        "render": "Project being render",
        "finalize": "Project being finalize",
        "archive": "Project being render"
    }

    useEffect(() => {
        ScrollingMod(display)
    }, [display])

    return (
        <>
        <div className={`loading-modal ${display && "force-display"}`}>
            <div className="content" style={{left: localContext.minNavigation && "50%"}}>
                <img className="icon" src={progressIcon} alt=""/>
                <h3>{trie && t(steps[trie.step])}</h3>
            </div>
        </div>
        </>
    )
}